var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _mask, _g2, _path10, _mask2, _g3, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _mask3, _g4, _path48, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerSupplyNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 84,
    fill: "none",
    viewBox: "0 -15 118 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9FE1D5",
    d: "M110.1 73H7c-1.1 0-2 .9-2 2v4.2c0 1.1.9 2 2 2h6.1c.3 0 .6-.1.8-.2l6.5-3c.3-.1.5-.2.8-.2h72c.2 0 .5 0 .7.1l7.7 3c.2.1.5.1.7.1h7.7c1.1 0 2-.9 2-2v-4.2c.1-.9-.8-1.8-1.9-1.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7CBEB3",
    d: "M48.5 42.21h-.8c-2.6 0-4.7-2.1-4.7-4.7v-16.4h5.5v21.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F8FA",
    d: "M110.345 76H7.577C5.555 76 4 74.804 4 73.293V54.847c0-1.385 1.4-2.518 3.266-2.644C26.086 50.881 24.566 50 48.286 50c23.097 0 44.016.881 62.448 2.203 1.866.126 3.266 1.26 3.266 2.644v18.446c0 1.51-1.633 2.707-3.655 2.707z",
    filter: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2EBED",
    d: "M110.345 58H7.577C5.555 58 4 57.77 4 57.48v-3.548c0-.266 1.4-.484 3.266-.508 18.82-.255 17.3-.424 41.02-.424 23.097 0 44.016.17 62.448.424 1.866.024 3.266.242 3.266.508v3.547c0 .291-1.633.521-3.655.521z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M113.992 53.514c.134 1.392-1.466 2.486-3.733 2.486H7.74c-2.133 0-3.866-1.193-3.733-2.486 2.4-16.907 4.666-24.962 7.066-41.868.4-2.785 3.2-5.172 7.332-6.365.267-.1.667-.199.933-.199C28.804 2.596 43.203-.188 60.933.01 76.93.21 89.863 2.695 98.66 5.082c.267.1.667.199.933.298 4.133 1.094 6.799 3.58 7.199 6.365l7.199 41.769z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M59.616 4.617A113.67 113.67 0 0 1 82.378 7.11C77.07 5.18 69.188 3.17 59.616 3.008A72.36 72.36 0 0 0 34.522 7.11c5.71-1.206 14.397-2.574 25.094-2.493z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#003F52",
    d: "M86 10.047C78.818 8.45 69.64 7 59 7s-19.818 1.45-27 3.047V35h54V10.047z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M85 10v24H32v1h54V10.287c-.399 0-.601-.143-1-.287z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.994 34H43.13l7.18-27H68l-7.006 27zM40.853 34H37l7.005-27h3.854l-7.006 27z",
    opacity: 0.2
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M68.777 53.015h.318l.516-1.509.516 1.509h.318l.732-2.115h-.387l-.5 1.557-.517-1.563h-.312l-.516 1.563-.5-1.557h-.4l.732 2.115zM71.106 53h.379l.216-.507h.993l.212.507h.39l-.924-2.115h-.341L71.106 53zm.73-.834l.36-.84.362.84h-.723zM73.903 53h.372v-1.758h.666V50.9h-1.704v.342h.666V53zM43.1 53h.379l.216-.507h.993L44.9 53h.39l-.924-2.115h-.342L43.1 53zm.73-.834l.36-.84.363.84h-.723zM45.65 53h.364v-1.5l.657.984h.012l.663-.99V53h.369v-2.1h-.393l-.64.993-.638-.993h-.393V53zM48.255 53h.37v-.675h.416c.462 0 .84-.246.84-.717v-.006c0-.423-.309-.702-.798-.702h-.828V53zm.37-1.008v-.756h.428c.276 0 .453.129.453.375v.006c0 .219-.174.375-.453.375h-.429zM18.53 53h.372v-1.758h.666V50.9h-1.704v.342h.666V53zM19.98 53h.37v-2.1h-.37V53zM20.912 53h.363v-1.5l.657.984h.012l.663-.99V53h.369v-2.1h-.393l-.64.993-.638-.993h-.393V53zM23.516 53h1.572v-.33h-1.203v-.564h1.053v-.33h-1.053v-.546h1.188v-.33h-1.557V53zM90.21 53.015h.323l.873-2.115h-.399l-.63 1.614-.633-1.614h-.408l.873 2.115zM92.64 53.036c.644 0 1.1-.495 1.1-1.086v-.006c0-.591-.45-1.08-1.095-1.08s-1.1.495-1.1 1.086v.006c0 .591.45 1.08 1.094 1.08zm.005-.339c-.417 0-.714-.339-.714-.747v-.006c0-.408.291-.741.708-.741s.714.339.714.747v.006c0 .408-.29.741-.708.741zM94.186 53h1.473v-.336h-1.104V50.9h-.369V53zM96.26 53h.373v-1.758h.666V50.9h-1.704v.342h.666V53zM97.24 53h.379l.216-.507h.993l.212.507h.39l-.924-2.115h-.341L97.24 53zm.73-.834l.36-.84.362.84h-.722zM100.658 53.036c.372 0 .669-.15.876-.327v-.882h-.894v.321h.537v.393a.857.857 0 0 1-.507.159c-.429 0-.714-.318-.714-.75v-.006c0-.402.294-.741.681-.741.267 0 .426.087.588.225l.234-.279c-.216-.183-.441-.285-.807-.285a1.07 1.07 0 0 0-1.083 1.086v.006c0 .612.432 1.08 1.089 1.08zM102.014 53h1.572v-.33h-1.203v-.564h1.053v-.33h-1.053v-.546h1.188v-.33h-1.557V53z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 15,
    height: 12,
    x: 90,
    y: 11,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CEC2A2",
    d: "M103.5 23H90.994A.995.995 0 0 1 90 22v-9.703a.997.997 0 0 1 1.252-.966c2.57.681 8.502 2.263 12.106 3.3a.988.988 0 0 1 .711.853c.161 1.546.552 5.305.631 6.016.1.9-.2 1.5-1.2 1.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FAAC48",
    d: "M103.928 23H90.994A.995.995 0 0 1 90 22V11.434c0-.695.69-1.182 1.347-.951 2.664.938 8.662 2.967 12.284 3.543.48.076.858.465.892.951l.477 6.841S105 23 103.928 23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB89",
    fillRule: "evenodd",
    d: "M91 12.5l12 3.5 1-1.5L91 11l-.007.015c-.993-.106-.993.39-.993.39V21.91C90 23 91 23 91 23V12.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC8E2A",
    fillRule: "evenodd",
    d: "M103.75 23c.15.306.316.543.75.543.656 0 .5-1.543.5-1.543l-1-7.5-1 1.5s.37 4.441.474 6H91l-.7.75c.2.25.7.25.7.25h12.75z",
    clipRule: "evenodd"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M92.492 19.03c.441 0 .75-.234.75-.627v-.006c0-.348-.23-.507-.675-.615-.402-.096-.498-.168-.498-.33v-.006c0-.138.126-.249.342-.249.192 0 .381.075.57.216l.198-.279a1.164 1.164 0 0 0-.762-.264c-.417 0-.717.25-.717.61v.005c0 .387.252.52.7.627.39.09.473.171.473.321v.006c0 .16-.144.264-.372.264-.26 0-.462-.099-.663-.273l-.222.264c.252.225.555.336.876.336zM94.148 19h.372v-1.758h.666V16.9h-1.704v.342h.666V19zM95.128 19h.378l.216-.507h.993l.213.507h.39l-.924-2.115h-.342L95.128 19zm.729-.834l.36-.84.363.84h-.723zM97.678 19h.37v-.732h.461l.516.732h.435l-.567-.795c.294-.084.501-.29.501-.636v-.006a.635.635 0 0 0-.174-.453c-.135-.132-.342-.21-.606-.21h-.936V19zm.37-1.059v-.705h.536c.273 0 .435.123.435.348v.006c0 .213-.168.351-.432.351h-.54zM100.353 19h.372v-1.758h.666V16.9h-1.704v.342h.666V19z"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 16,
    height: 10,
    x: 90,
    y: 25,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CEC2A2",
    d: "M104.895 35H91a1 1 0 0 1-1-1v-8c0-.552.443-1 .995-1H104.1c.514 0 .94.39.991.9l.8 8a1 1 0 0 1-.995 1.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#92D6CA",
    d: "M104.949 35H91a1 1 0 0 1-1-1v-8c0-.552.442-1 .994-1h13.56c.533 0 .967.418.994.95l.4 8a1 1 0 0 1-.999 1.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2FFF7",
    fillRule: "evenodd",
    d: "M90 33.91C90 35 91 35 91 35v-9h13.979c.146-1-.52-1-.52-1H91v-1.984c-1-.11-1 .39-1 .39v1.632c-1 .183-1 .962-1 .962h1v7.91z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D9E90",
    fillRule: "evenodd",
    d: "M105.078 34.995l.431 3.593.689.7c.247-.038.468-.699.468-.699s-1.282-11.282-1.568-13.65L104 26l.959 8H91l-.8.5c0 .219.617.5.617.5H105a.578.578 0 0 0 .078-.005zm.02-10.055zm0 0a21.18 21.18 0 0 0-.053-.419c-.062-.395-.545-.521-.545-.521l.598.94z",
    clipRule: "evenodd"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M94.376 31.03c.44 0 .75-.234.75-.627v-.006c0-.348-.232-.507-.675-.615-.402-.096-.498-.168-.498-.33v-.006c0-.138.126-.249.341-.249.193 0 .382.075.57.216l.198-.279a1.164 1.164 0 0 0-.761-.264c-.418 0-.718.249-.718.609v.006c0 .387.252.519.7.627.39.09.474.171.474.321v.006c0 .159-.145.264-.373.264-.26 0-.462-.099-.662-.273l-.222.264c.251.225.555.336.876.336zM96.031 31h.372v-1.758h.666V28.9h-1.704v.342h.666V31zM98.349 31.036c.645 0 1.1-.495 1.1-1.086v-.006c0-.591-.45-1.08-1.094-1.08-.645 0-1.101.495-1.101 1.086v.006c0 .591.45 1.08 1.095 1.08zm.006-.339c-.417 0-.714-.339-.714-.747v-.006c0-.408.29-.741.708-.741.417 0 .714.339.714.747v.006c0 .408-.291.741-.708.741zM99.895 31h.369v-.675h.417c.462 0 .84-.246.84-.717v-.006c0-.423-.309-.702-.798-.702h-.828V31zm.369-1.008v-.756h.429c.276 0 .453.129.453.375v.006c0 .219-.174.375-.453.375h-.429zM77.5 73.167a6.667 6.667 0 1 0 0-13.334 6.667 6.667 0 0 0 0 13.334z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1272D",
    fillRule: "evenodd",
    d: "M77.5 60.667a5.833 5.833 0 1 0 0 11.666 5.833 5.833 0 0 0 0-11.666zM70 66.5a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M40.5 73.167a6.667 6.667 0 1 0 0-13.334 6.667 6.667 0 0 0 0 13.334z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    fillRule: "evenodd",
    d: "M40.5 60.667a5.833 5.833 0 1 0 0 11.666 5.833 5.833 0 0 0 0-11.666zM33 66.5a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M56.374 68.7l2.524-4.303 2.524 4.303h-5.047zm2.352-4.601a.2.2 0 0 1 .345 0l2.698 4.6a.2.2 0 0 1-.172.301H56.2a.2.2 0 0 1-.172-.3l2.698-4.601zm-.077 1.454h.5l-.6 1.299.799-.45-.45 1.699.25-.15-.5.65-.1-.8.15.2.2-1.149-.749.45.5-1.749z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#92D6CA",
    d: "M11 40a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2FFF7",
    fillRule: "evenodd",
    d: "M11 40v8c0 1 1 1 1 1v-9h9s0-1-1-1h-8c-.347 0-.574.12-.722.278-.157.148-.278.375-.278.722z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D9E90",
    fillRule: "evenodd",
    d: "M21 40v8c0 .347-.12.574-.278.722-.148.157-.375.278-.722.278h-8c-.5 0-.7-.25-.7-.25L12 48h8v-8l.75-.7s.25.2.25.7z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M16.481 45.27c-.214.307-.748.307-.962 0l-1.444-2.078c-.214-.307.054-.692.482-.692h2.886c.428 0 .696.385.482.692L16.48 45.27z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#92D6CA",
    d: "M22 40a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2FFF7",
    fillRule: "evenodd",
    d: "M22 40v8c0 1 1 1 1 1v-9h9s0-1-1-1h-8c-.347 0-.574.12-.722.278-.157.148-.278.375-.278.722z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D9E90",
    fillRule: "evenodd",
    d: "M32 40v8c0 .347-.12.574-.278.722-.148.157-.375.278-.722.278h-8c-.5 0-.7-.25-.7-.25L23 48h8v-8l.75-.7s.25.2.25.7z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M26.519 42.73c.214-.307.748-.307.962 0l1.444 2.078c.214.307-.054.692-.482.692h-2.887c-.427 0-.695-.385-.48-.692l1.443-2.077z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#92D6CA",
    d: "M86 40a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2FFF7",
    fillRule: "evenodd",
    d: "M86 40v8c0 1 1 1 1 1v-9h9s0-1-1-1h-8c-.347 0-.574.12-.722.278-.157.148-.278.375-.278.722z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D9E90",
    fillRule: "evenodd",
    d: "M96 40v8c0 .347-.12.574-.278.722-.148.157-.375.278-.722.278h-8c-.5 0-.7-.25-.7-.25L87 48h8v-8l.75-.7s.25.2.25.7z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M91.481 45.27c-.214.307-.748.307-.962 0l-1.444-2.078c-.214-.307.054-.692.481-.692h2.888c.427 0 .695.385.48.692l-1.443 2.077z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#92D6CA",
    d: "M97 40a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2FFF7",
    fillRule: "evenodd",
    d: "M97 40v8c0 1 1 1 1 1v-9h9s0-1-1-1h-8c-.347 0-.574.12-.722.278-.157.148-.278.375-.278.722z",
    clipRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D9E90",
    fillRule: "evenodd",
    d: "M107 40v8c0 .347-.121.574-.278.722-.148.157-.375.278-.722.278h-8c-.5 0-.7-.25-.7-.25L98 48h8v-8l.75-.7s.25.2.25.7z",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M101.519 42.73c.214-.307.748-.307.962 0l1.444 2.078c.214.307-.054.692-.481.692h-2.888c-.427 0-.695-.385-.481-.692l1.444-2.077z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#92D6CA",
    d: "M61 40a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-8z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2FFF7",
    fillRule: "evenodd",
    d: "M61 40v8c0 1 1 1 1 1v-9h9s0-1-1-1h-8c-.347 0-.574.12-.722.278-.157.148-.278.375-.278.722z",
    clipRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D9E90",
    fillRule: "evenodd",
    d: "M71 40v8c0 .347-.12.574-.278.722-.148.157-.375.278-.722.278h-8c-.5 0-.7-.25-.7-.25L62 48h8v-8l.75-.7s.25.2.25.7z",
    clipRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M66.481 45.27c-.214.307-.748.307-.962 0l-1.444-2.078c-.214-.307.054-.692.481-.692h2.888c.427 0 .695.385.48.692l-1.443 2.077z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#92D6CA",
    d: "M72 40a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-8z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2FFF7",
    fillRule: "evenodd",
    d: "M72 40v8c0 1 1 1 1 1v-9h9s0-1-1-1h-8c-.347 0-.574.12-.722.278-.157.148-.278.375-.278.722z",
    clipRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D9E90",
    fillRule: "evenodd",
    d: "M82 40v8c0 .347-.12.574-.278.722-.148.157-.375.278-.722.278h-8c-.5 0-.7-.25-.7-.25L73 48h8v-8l.75-.7s.25.2.25.7z",
    clipRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M76.519 42.73c.214-.307.748-.307.962 0l1.444 2.078c.214.307-.054.692-.481.692h-2.888c-.427 0-.695-.385-.48-.692l1.443-2.077z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#92D6CA",
    d: "M36 40a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-8z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2FFF7",
    fillRule: "evenodd",
    d: "M36 40v8c0 1 1 1 1 1v-9h9s0-1-1-1h-8c-.347 0-.574.12-.722.278-.157.148-.278.375-.278.722z",
    clipRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D9E90",
    fillRule: "evenodd",
    d: "M46 40v8c0 .347-.12.574-.278.722-.148.157-.375.278-.722.278h-8c-.5 0-.7-.25-.7-.25L37 48h8v-8l.75-.7s.25.2.25.7z",
    clipRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M41.481 45.27c-.214.307-.748.307-.962 0l-1.444-2.078c-.214-.307.054-.692.481-.692h2.888c.427 0 .695.385.48.692l-1.443 2.077z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#92D6CA",
    d: "M47 40a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-8z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2FFF7",
    fillRule: "evenodd",
    d: "M47 40v8c0 1 1 1 1 1v-9h9s0-1-1-1h-8c-.347 0-.574.12-.722.278-.157.148-.278.375-.278.722z",
    clipRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D9E90",
    fillRule: "evenodd",
    d: "M57 40v8c0 .347-.12.574-.278.722-.148.157-.375.278-.722.278h-8c-.5 0-.7-.25-.7-.25L48 48h8v-8l.75-.7s.25.2.25.7z",
    clipRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M51.519 42.73c.214-.307.748-.307.962 0l1.444 2.078c.214.307-.054.692-.481.692h-2.888c-.427 0-.695-.385-.48-.692l1.443-2.077z"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 16,
    height: 24,
    x: 12,
    y: 11,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#37C8FE",
    d: "M13.1 35H27a1 1 0 0 0 1-1V12.244a1 1 0 0 0-1.213-.977c-2.569.563-8.602 1.88-12.061 2.586a1 1 0 0 0-.796.887l-1.826 19.165A1 1 0 0 0 13.1 35z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#92D6CA",
    d: "M13.1 35H27a1 1 0 0 0 1-1V12.244a1 1 0 0 0-1.213-.977c-2.569.563-8.602 1.88-12.061 2.586a1 1 0 0 0-.796.887l-1.826 19.165A1 1 0 0 0 13.1 35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2FFF7",
    fillRule: "evenodd",
    d: "M27 12l-12 3h-.105C14.483 18.93 13 33.139 13 34c0 1-1 .5-1 .5l1.93-19.745c.029-.3.19-.58.431-.725l-.01-.08L28.5 10.469 27.5 12H27z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D9E90",
    fillRule: "evenodd",
    d: "M28 34c0 1-1 1-1 1v-.031H12l.707-.707a1 1 0 0 1 .707-.293H27v-22c.5 0 1-1 1-1V34z",
    clipRule: "evenodd"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.06 20.976a.507.507 0 0 0-1.015 0v4.04a.507.507 0 0 0 1.014 0v-4.04zm-2.318 1.334a.507.507 0 0 0-.717-.717 3.5 3.5 0 1 0 4.95 0 .507.507 0 0 0-.717.717 2.486 2.486 0 1 1-3.516 0z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 118,
    height: 34,
    x: 0,
    y: 50,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerSupplyNew);
export default __webpack_public_path__ + "static/media/Power_Supply_New.f828c8724feea41f4b63b73e757bb233.svg";
export { ForwardRef as ReactComponent };